'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Paginator$$anon$2() {
}
export { $c_Lpresto_Paginator$$anon$2 as $c_Lpresto_Paginator$$anon$2 };
$p = $c_Lpresto_Paginator$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_Paginator$$anon$2;
/** @constructor */
function $h_Lpresto_Paginator$$anon$2() {
}
export { $h_Lpresto_Paginator$$anon$2 as $h_Lpresto_Paginator$$anon$2 };
$h_Lpresto_Paginator$$anon$2.prototype = $p;
$p.cJv = (function(x) {
  return ((x instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some) && true);
});
$p.cA6 = (function(x, default$1) {
  return ((x instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some) ? (x.a0 | 0) : default$1.w(x));
});
$p.cb = (function(x) {
  return this.cJv(x);
});
$p.bk = (function(x, default$1) {
  return this.cA6(x, default$1);
});
var $d_Lpresto_Paginator$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Paginator$$anon$2, "presto.Paginator$$anon$2", ({
  MO: 1,
  a4: 1,
  t: 1,
  A: 1,
  a: 1
}));
export { $d_Lpresto_Paginator$$anon$2 as $d_Lpresto_Paginator$$anon$2 };
//# sourceMappingURL=presto.-Paginator$$anon$2.js.map
